import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { SEGMENT_MODE, type SegmentMode } from "../constants";
import { useSegmentPaths } from "../hooks/useSegmentPaths";

import { SegmentedControl } from "@/components/ui/v2/segmented-control";
import { SEGMENT_TOUR_TARGET } from "@/features/segments/tour/constants";
import { useTourTarget } from "@/features/tours/useTourTarget";

type ModeSwitchProps = {
  mode: SegmentMode;
  segmentId: string;
};

export function ModeSwitch({ mode, segmentId }: ModeSwitchProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const paths = useSegmentPaths();
  const modeSwitchRef = useTourTarget<HTMLDivElement>(SEGMENT_TOUR_TARGET.MODE_SWITCH);

  const handleModeChange = (next: SegmentMode) => {
    const path = next === SEGMENT_MODE.EDIT ? paths.edit(segmentId) : paths.view(segmentId);
    navigate(`${path}${search}`);
  };

  const options = [
    { value: SEGMENT_MODE.VIEW, label: t("admin.segments.builder.mode.view") },
    { value: SEGMENT_MODE.EDIT, label: t("admin.segments.builder.mode.edit") },
  ];

  return (
    <SegmentedControl
      value={mode}
      onValueChange={handleModeChange}
      options={options}
      label={t("admin.segments.builder.mode.label")}
      rootRef={modeSwitchRef}
    />
  );
}
